<template>
    <div class="p-4">
        <template v-if="canMakeEntry">
            <h1 class="text-xl font-semibold mb-1">Log entry</h1>
            <p class="text-base-content/50 text-sm mb-4">Upload a picture of your meal, snack or drink.</p>
            <file-upload
                v-if="!uploading"
                @uploaded="fileUploaded"
            />
            <div
                v-else
                class="flex justify-center py-4"
            >
                <span class="loading loading-spinner loading-md"></span>
            </div>
        </template>

        <template v-else-if="entryProcessingId">
            <h1 class="text-xl font-semibold mb-1">Processing...</h1>
            <p class="text-base-content/50 text-sm mb-4">Sit tight, we're analysing your entry.</p>
            <div class="flex justify-center py-4">
                <span class="loading loading-spinner loading-md"></span>
            </div>
        </template>

        <template v-else>
            <h1 class="text-xl font-semibold mb-1">You're done for now</h1>
            <p class="text-base-content/50 text-sm">Come back after your next meal.</p>
        </template>
    </div>
</template>

<script>
import apiClient from 'api/apiClient.js';
import FileUpload from 'components/inputs/file-upload.vue';

export default {
    name: 'NewEntry',
    components: { FileUpload },
    props: {
        canMakeEntry: {
            type: Boolean,
            required: true,
        },
        entryProcessingId: {
            type: String,
            default: null,
        },
    },
    emits: ['entry-processed'],
    data: () => ({
        uploading: false,
    }),
    methods: {
        async fileUploaded(file) {
            if (!file || this.uploading) return;
            this.uploading = true;
            try {
                const formData = new FormData();
                formData.append('file1', file);
                await apiClient.post('/api/home/new-entry', formData);
                this.$emit('entry-processed');
            } catch (error) {
                console.error('Upload failed:', error);
            } finally {
                this.uploading = false;
            }
        },
    },
};
</script>
